import React from 'react';
import PropTypes from 'prop-types';

import { getConcessionTagTextList } from 'common/concessionHelpers';
import { formatPrice } from 'common/formatters';

import SrText from 'client/components/SrText';
import SrFlex from 'client/components/SrFlex';
import SrTextList from 'client/components/SrTextList';

import SrTooltip, { SR_TOOLTIP_POSITION_CENTER_UNDERNEATH } from 'client/components/SrTooltip';
import SrTag, { SR_TAG_THEME_BLUE_WHITE } from 'client/components/SrTag/SrTag';

const SrConcessionTag = ({ concession, rentPrice }) => {
  const concessionTextList = getConcessionTagTextList({ concession, rentPrice });

  return (
    <SrTooltip
      icon={
        <SrTag theme={SR_TAG_THEME_BLUE_WHITE} variation="concessionTag">
          <SrFlex align="center">
            <SrText font="greycliff" fontSize="12px" paddingLeft="4px" paddingTop="2px">
              {`${formatPrice(concession.amount)} Concession`}
            </SrText>
          </SrFlex>
        </SrTag>
      }
      position={SR_TOOLTIP_POSITION_CENTER_UNDERNEATH}
      className="tooltip-concessionTag"
      bgColor="blueBright"
    >
      <SrTextList font="greycliff" fontSize="14px" weight={500} textList={concessionTextList} />
    </SrTooltip>
  );
};

SrConcessionTag.displayName = 'SrConcessionTag';

SrConcessionTag.propTypes = {
  concession: PropTypes.object.isRequired,
  rentPrice: PropTypes.number.isRequired,
};

export default SrConcessionTag;
